import * as React from "react";

export type EnumValue = string | null;

export function EnumEditor({
  value,
  options,
  onCommit,
  onCancel,
}: {
  value: EnumValue;
  options: string[];
  onCommit: (next: EnumValue) => void;
  onCancel: () => void;
}) {
  const committedRef = React.useRef(false);

  const commit = React.useCallback(
    (next: string) => {
      if (committedRef.current) return;
      committedRef.current = true;
      onCommit(next);
    },
    [onCommit],
  );

  const cancel = React.useCallback(() => {
    if (committedRef.current) return;
    committedRef.current = true;
    onCancel();
  }, [onCancel]);

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === "Escape") {
      e.preventDefault();
      cancel();
    }
  };

  return (
    <div className="inline-flex flex-wrap gap-1" onKeyDown={handleKeyDown}>
      {options.map((opt, i) => (
        <button
          key={opt}
          type="button"
          autoFocus={i === 0}
          aria-pressed={value === opt}
          onClick={() => commit(opt)}
          className="rounded border border-border px-2 py-1 text-xs hover:bg-muted aria-pressed:bg-foreground aria-pressed:text-background"
        >
          {opt}
        </button>
      ))}
    </div>
  );
}
